var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',_vm._b({attrs:{"value":_vm.selectedRoles,"items":_vm.roles,"clearable":"","item-text":"name","return-object":"","loading":_vm.isLoading},on:{"change":_vm.emitInput}},'v-autocomplete',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }